import I18n from 'I18n';
import UIIcon from 'UIComponents/icon/UIIcon';
import { useTourTrackingMethod } from 'ui-shepherd-react/contexts/TourTrackingContext';
import { MinimiseIcon, EnlargeIcon } from './Icons';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const MinimizedContent = ({
  minimized,
  children,
  onClickEnlarge,
  onClickMinimize,
  stepKey,
  tourKey
}) => {
  const trackTourInteraction = useTourTrackingMethod('trackTourInteraction');
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [minimized && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(EnlargeIcon, {
        "data-test-id": "expand-icon",
        onClick: () => {
          if (trackTourInteraction) {
            trackTourInteraction(tourKey, stepKey, 'expand tooltip');
          }
          onClickEnlarge();
        },
        children: /*#__PURE__*/_jsx(UIIcon, {
          name: "enlarge"
        })
      }), /*#__PURE__*/_jsxs("h5", {
        className: "m-right-1",
        children: [I18n.text('shepherd-react.next'), ": "]
      })]
    }), children, !minimized && /*#__PURE__*/_jsx(MinimiseIcon, {
      "data-test-id": "minimize-icon",
      onClick: () => {
        if (trackTourInteraction) {
          trackTourInteraction(tourKey, stepKey, 'minimize tooltip');
        }
        onClickMinimize();
      },
      children: /*#__PURE__*/_jsx(UIIcon, {
        name: "minus"
      })
    })]
  });
};
export { MinimizedContent };